// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/refund.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Agency } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Price, Travel } from "./common_pb";
import { file_travel_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/refund.proto.
 */
export const file_travel_v1_refund: GenFile = /*@__PURE__*/
  fileDesc("ChZ0cmF2ZWwvdjEvcmVmdW5kLnByb3RvEgl0cmF2ZWwudjEiLgoZUmVmdW5kU2VydmljZVF1b3RlUmVxdWVzdBIRCgl0cmF2ZWxfaWQYASABKAkiygQKGlJlZnVuZFNlcnZpY2VRdW90ZVJlc3BvbnNlEiEKBnRyYXZlbBgBIAEoCzIRLnRyYXZlbC52MS5UcmF2ZWwSJQoLYmFzZV9hbW91bnQYAiABKAsyEC50cmF2ZWwudjEuUHJpY2USKAoOY292ZXJlZF9hbW91bnQYAyABKAsyEC50cmF2ZWwudjEuUHJpY2USLgoUb3V0X29mX3BvY2tldF9hbW91bnQYBCABKAsyEC50cmF2ZWwudjEuUHJpY2USJAoKZml4ZWRfZmVlcxgFIAEoCzIQLnRyYXZlbC52MS5QcmljZRInCg12YXJpYWJsZV9mZWVzGAYgASgLMhAudHJhdmVsLnYxLlByaWNlEikKD3Byb2Nlc3NpbmdfZmVlcxgHIAEoCzIQLnRyYXZlbC52MS5QcmljZRIuChRjYWlzc2VfcmVmdW5kX2Ftb3VudBgIIAEoCzIQLnRyYXZlbC52MS5QcmljZRIwChZjdXN0b21lcl9yZWZ1bmRfYW1vdW50GAkgASgLMhAudHJhdmVsLnYxLlByaWNlEiYKDHRvdGFsX2Ftb3VudBgKIAEoCzIQLnRyYXZlbC52MS5QcmljZRIuChRjdXN0b21lcl9hZ2VuY3lfZmVlcxgLIAEoCzIQLnRyYXZlbC52MS5QcmljZRIbChNjb3ZlcmFnZV9wZXJjZW50YWdlGAwgASgFEiAKGG91dF9vZl9wb2NrZXRfcGVyY2VudGFnZRgNIAEoBRIVCg1mdWxseV9jb3ZlcmVkGA4gASgIIj8KGlJlcXVpcmVzQWdlbmN5Q29udGFjdEVycm9yEiEKBmFnZW5jeRgBIAEoCzIRLmFnZW5jeS52MS5BZ2VuY3kiMAobUmVmdW5kU2VydmljZUNvbmZpcm1SZXF1ZXN0EhEKCXRyYXZlbF9pZBgBIAEoCSIeChxSZWZ1bmRTZXJ2aWNlQ29uZmlybVJlc3BvbnNlMsUBCg1SZWZ1bmRTZXJ2aWNlElYKBVF1b3RlEiQudHJhdmVsLnYxLlJlZnVuZFNlcnZpY2VRdW90ZVJlcXVlc3QaJS50cmF2ZWwudjEuUmVmdW5kU2VydmljZVF1b3RlUmVzcG9uc2UiABJcCgdDb25maXJtEiYudHJhdmVsLnYxLlJlZnVuZFNlcnZpY2VDb25maXJtUmVxdWVzdBonLnRyYXZlbC52MS5SZWZ1bmRTZXJ2aWNlQ29uZmlybVJlc3BvbnNlIgBiBnByb3RvMw", [file_agency_v1_agency, file_travel_v1_common]);

/**
 * @generated from message travel.v1.RefundServiceQuoteRequest
 */
export type RefundServiceQuoteRequest = Message<"travel.v1.RefundServiceQuoteRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;
};

/**
 * Describes the message travel.v1.RefundServiceQuoteRequest.
 * Use `create(RefundServiceQuoteRequestSchema)` to create a new message.
 */
export const RefundServiceQuoteRequestSchema: GenMessage<RefundServiceQuoteRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_refund, 0);

/**
 * @generated from message travel.v1.RefundServiceQuoteResponse
 */
export type RefundServiceQuoteResponse = Message<"travel.v1.RefundServiceQuoteResponse"> & {
  /**
   * @generated from field: travel.v1.Travel travel = 1;
   */
  travel?: Travel;

  /**
   * @generated from field: travel.v1.Price base_amount = 2;
   */
  baseAmount?: Price;

  /**
   * @generated from field: travel.v1.Price covered_amount = 3;
   */
  coveredAmount?: Price;

  /**
   * @generated from field: travel.v1.Price out_of_pocket_amount = 4;
   */
  outOfPocketAmount?: Price;

  /**
   * @generated from field: travel.v1.Price fixed_fees = 5;
   */
  fixedFees?: Price;

  /**
   * @generated from field: travel.v1.Price variable_fees = 6;
   */
  variableFees?: Price;

  /**
   * @generated from field: travel.v1.Price processing_fees = 7;
   */
  processingFees?: Price;

  /**
   * @generated from field: travel.v1.Price caisse_refund_amount = 8;
   */
  caisseRefundAmount?: Price;

  /**
   * @generated from field: travel.v1.Price customer_refund_amount = 9;
   */
  customerRefundAmount?: Price;

  /**
   * @generated from field: travel.v1.Price total_amount = 10;
   */
  totalAmount?: Price;

  /**
   * @generated from field: travel.v1.Price customer_agency_fees = 11;
   */
  customerAgencyFees?: Price;

  /**
   * @generated from field: int32 coverage_percentage = 12;
   */
  coveragePercentage: number;

  /**
   * @generated from field: int32 out_of_pocket_percentage = 13;
   */
  outOfPocketPercentage: number;

  /**
   * @generated from field: bool fully_covered = 14;
   */
  fullyCovered: boolean;
};

/**
 * Describes the message travel.v1.RefundServiceQuoteResponse.
 * Use `create(RefundServiceQuoteResponseSchema)` to create a new message.
 */
export const RefundServiceQuoteResponseSchema: GenMessage<RefundServiceQuoteResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_refund, 1);

/**
 * @generated from message travel.v1.RequiresAgencyContactError
 */
export type RequiresAgencyContactError = Message<"travel.v1.RequiresAgencyContactError"> & {
  /**
   * @generated from field: agency.v1.Agency agency = 1;
   */
  agency?: Agency;
};

/**
 * Describes the message travel.v1.RequiresAgencyContactError.
 * Use `create(RequiresAgencyContactErrorSchema)` to create a new message.
 */
export const RequiresAgencyContactErrorSchema: GenMessage<RequiresAgencyContactError> = /*@__PURE__*/
  messageDesc(file_travel_v1_refund, 2);

/**
 * @generated from message travel.v1.RefundServiceConfirmRequest
 */
export type RefundServiceConfirmRequest = Message<"travel.v1.RefundServiceConfirmRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;
};

/**
 * Describes the message travel.v1.RefundServiceConfirmRequest.
 * Use `create(RefundServiceConfirmRequestSchema)` to create a new message.
 */
export const RefundServiceConfirmRequestSchema: GenMessage<RefundServiceConfirmRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_refund, 3);

/**
 * @generated from message travel.v1.RefundServiceConfirmResponse
 */
export type RefundServiceConfirmResponse = Message<"travel.v1.RefundServiceConfirmResponse"> & {
};

/**
 * Describes the message travel.v1.RefundServiceConfirmResponse.
 * Use `create(RefundServiceConfirmResponseSchema)` to create a new message.
 */
export const RefundServiceConfirmResponseSchema: GenMessage<RefundServiceConfirmResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_refund, 4);

/**
 * @generated from service travel.v1.RefundService
 */
export const RefundService: GenService<{
  /**
   * @generated from rpc travel.v1.RefundService.Quote
   */
  quote: {
    methodKind: "unary";
    input: typeof RefundServiceQuoteRequestSchema;
    output: typeof RefundServiceQuoteResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.RefundService.Confirm
   */
  confirm: {
    methodKind: "unary";
    input: typeof RefundServiceConfirmRequestSchema;
    output: typeof RefundServiceConfirmResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_refund, 0);

